<template>
    <div ref="panel" class="panel"
        :style="{
            background: classInfo.color ? classInfo.color : layerColors[level % 4],
            zIndex: level,
            top: top + 15 * level + 'px',
            left: left + 15 * (level + pos) + 'px',
        }"
    >
        <div class="overflow-auto" style="height: 100%" :class="{ 'text-light': classInfo.color }">
            <el-tooltip manual v-model="classInfoTooltip" @mouseenter.native="tooltipEnter('classInfoTooltip')" @mouseleave.native="tooltipLeave('classInfoTooltip')">
                <div slot="content">
                    <table>
                        <tbody>
                            <tr>
                                <th v-for="title in rawTitle" :key="title" class="border-left border-bottom p-2">{{ title }}</th>
                            </tr>
                            <tr>
                                <td v-for="(info, index) in classInfo" :key="index" class="border-left p-2">{{ info }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="cursor-pointer">
                    <u>{{ getRowInfo(classInfo, 'subjectName') }} ({{ getRowInfo(classInfo, 'classType') }})</u>
                </div>
            </el-tooltip>

            <div @click="$emit('deletePanel', { index, day: getRowInfo(classInfo, 'day') })"
                class="absolute-right cursor-pointer text-danger"><i class="fas fa-times-circle"></i></div>
            <div>
                <small>
                    Mã lớp:
                    <el-tooltip
                        manual
                        :content="classCodeCopied ? 'Click để hủy đánh dấu' : 'Click để copy và đánh dấu'"
                        v-model="classCodeTooltip"
                        @mouseenter.native="tooltipEnter('classCodeTooltip')"
                        @mouseleave.native="tooltipLeave('classCodeTooltip')"
                    >
                        <b class="cursor-pointer button" :class="classCodeCopied ? 'press' : ''" @click="copyClassCode()">
                            {{ getRowInfo(classInfo, 'classCode') }}
                            <i :class="classCodeCopied ? 'fas' : 'far'" class="fa-check-circle"></i>
                        </b>
                    </el-tooltip>
                    , Mã lớp kèm:
					<el-tooltip content="Click để thêm lớp kèm">
						<b @click="$emit('addClass2', { classCode: getRowInfo(classInfo, 'classCode2'), subjectCode: getRowInfo(classInfo, 'subjectCode'), classInfo: classInfo })"
							class="cursor-pointer" :class="getRowInfo(classInfo, 'classCode2') ? 'button' : ''">
							{{ getRowInfo(classInfo, 'classCode2') }}
						</b>
					</el-tooltip>
                </small><br>
                <small>Phòng: {{ getRowInfo(classInfo, 'room') }} (Tuần {{ getRowInfo(classInfo, 'week') }})</small>
            </div>

            <div class="color-picker ml-md-2">
                <el-tooltip content="Đổi màu">
                    <i @click="$refs['colorInput'].handleTrigger()" class="fas fa-eye-dropper cursor-pointer"></i>
                </el-tooltip>
                <el-color-picker ref="colorInput" v-model="color" size="small" @change="$emit('changeColor', { 'color': color })" />
            </div>

            <div class="layer-control">
                <el-tooltip content="Dịch sang trái">
                    <i @click="pos--" class="fas fa-arrow-left cursor-pointer"></i>
                </el-tooltip>
                <el-tooltip :disabled="pos == 0" content="Nháy đúp chuột để về vị trí cũ">
                    <i @dblclick="pos = 0" class="far fa-dot-circle mx-1" :class="{ 'cursor-pointer': pos != 0 }"></i>
                </el-tooltip>
                <el-tooltip content="Dịch sang phải">
                    <i @click="pos++" class="fas fa-arrow-right cursor-pointer"></i>
                </el-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['top', 'left', 'classInfo', 'title', 'titleTrans', 'index', 'level', 'rawTitle', 'panelRatio'],
    data() {
        return {
            layerColors: ['linear-gradient(to right, #50CBFA , #5AF4CA)', 'linear-gradient(to right, #47DCDE , #47DE8B)', 'linear-gradient(to right, #5AF4CA , #50FA6D)', 'linear-gradient(to right, #50FA6D , #50CBFA)'],
            classInfoTooltip: false,
            classCodeTooltip: false,
            tooltipTimeout: {},
            classCodeCopied: false,
            color: '',
            pos: 0,
        }
    },
    methods: {
        getRowInfo(data, field) {
            return data[this.title[this.titleTrans[field]]]
        },
        tooltipEnter(tooltipName) {
            this.tooltipTimeout[tooltipName] = setTimeout(() => {
                this[tooltipName] = true
            }, 400)
        },
        tooltipLeave(tooltipName) {
            this[tooltipName] = false
            if(this.tooltipTimeout[tooltipName]) clearTimeout(this.tooltipTimeout[tooltipName])
            this.tooltipTimeout[tooltipName] = null
        },
        copyClassCode() {
            this.classCodeCopied = !this.classCodeCopied
            if(this.classCodeCopied) {

				if (navigator?.clipboard?.writeText) {

					const classCode = this.getRowInfo(this.classInfo, 'classCode')
					navigator.clipboard.writeText(classCode)
					this.$toast.success(`Đã copy ${classCode} (${this.getRowInfo(this.classInfo, 'subjectName')})!`)
				}
            }
        },
    },
    mounted(){
        let panel = this.$refs.panel
        panel.style.width = $('#anchor').width() + 30 + 'px'
        panel.style.height = (this.classInfo.end - this.classInfo.start) / this.panelRatio + 'px'
    }
}
</script>

<style scoped>
    .panel {
        position: absolute;
        border-radius: 10px;
        transition-timing-function: ease;
        transition-duration: 0.5s;
        box-shadow:
            12px 12px 16px 0 rgba(255, 255, 255, 0.3) inset,
            -8px -8px 12px 0 rgba(0, 0, 0, .25) inset;
        /* box-shadow: inset 0px 5px 10px 0px rgba(0, 0, 0, 0.5); */ /* concave effect */
    }
    .overflow-auto::-webkit-scrollbar {
        display: none;
    }
    .panel:hover {
        z-index: 10 !important;
        box-shadow:
            12px 12px 16px 0 rgba(255, 255, 255, 0.3) inset,
            -12px -12px 12px 0 rgba(0, 0, 0, .25) inset,
            12px 12px 16px 0 rgba(0, 0, 0, 0.25);
        transform: translateY(-5px) translateX(-5px);
        /* box-shadow: 10px 10px 5px grey, inset 0px 10px 20px 2px rgba(0, 0, 0, 0.25); */ /* concave hover effect */
    }
    .panel:hover .color-picker, .panel:hover .layer-control {
        display: block;
    }
    .el-tooltip {
        width: fit-content;
        margin: 0 auto;
    }
    .info {
        border: 1px solid;
        border-radius: 50%;
        width: 20px;
        height: 20px;
    }
    .absolute-right {
        position: absolute;
        right: 0;
        top: -10px;
    }
    .color-picker {
        position: absolute;
        bottom: 0;
        display: none;
    }
    .el-color-picker {
        opacity: 0;
        width: 0;
    }
    .layer-control {
        position: absolute;
        bottom: 0;
        right: 0;
        display: none;
    }

	.button {
		border: 1px solid;
		padding: 2px;
		border-radius: 5px;
		box-shadow: 2px 2px darkcyan;
	}
	.button.press {
		box-shadow: none;
	}
</style>